import { FORM_ERROR } from 'final-form'

import { WbacService } from '@cinch/oxd-utils/requests/src'
import * as Storage from '@cinch/oxd-utils/storage/src'
import { VehicleInformation, Stage } from '../../types'
import processVehicleInformation from './process-vehicle-information'
import { NavigateFn } from '@reach/router'

const submitVrm = (vrm: string, navigate: NavigateFn) => {
  return new Promise((resolve) => {
    const { token: storageToken } = Storage.get(Storage.StorageKeys.wbac)

    return WbacService.post<VehicleInformation>(
      '/vehicles',
      { vrm, journeyName: 'StandardQuote' },
      { headers: { Authorization: `JWT ${storageToken}` } },
    )
      .then((res) => res.data)
      .then(processVehicleInformation)
      .then(({ vehicleInformation, stage }) => {
        const options = { state: { vehicleInformation } }

        switch (stage) {
          case Stage.VehicleQuestions:
            navigate('/sell/details', options)
            break
          case Stage.VehicleMulticar:
            navigate('/sell/car', options)
            break
          case Stage.VehicleRegistrationCheck:
            navigate(`/sell/check-registration/${vrm}`)
            break
          default:
            break
        }
        resolve()
      })
      .catch((e) => resolve({ [FORM_ERROR]: e.message }))
  })
}

export default submitVrm
